import { Box, Button, Stack, Typography } from '@mui/material';
import { getSvg } from '@/utils/get-svg';

interface NotFoundProps {
  title: string;
  description: string;
  buttonText?: string;
  href?: string;
  centered?: boolean;
  onClick?: () => void;
}

export const NotFound = ({
  title,
  description,
  buttonText,
  href,
  centered = false,
  onClick,
}: NotFoundProps) => {
  const centeredStyle = centered ? 'center' : undefined;
  return (
    <Stack
      spacing={2}
      alignItems={centeredStyle}
      textAlign={centeredStyle}
      justifyContent={centeredStyle}
      sx={centered ? { height: '100%', width: '100%' } : undefined}
    >
      <Box
        component="img"
        src={getSvg('empty_state_catalog.svg')}
        sx={{ width: 130 }}
      />
      <Typography component="p" variant="h2" fontWeight="semibold">
        {title}
      </Typography>
      <Typography component="p" variant="body1">
        {description}
      </Typography>
      {buttonText && (
        <Button
          href={href}
          onClick={onClick}
          variant="contained"
          sx={{ width: 'fit-content' }}
        >
          {buttonText}
        </Button>
      )}
    </Stack>
  );
};
